import * as React from 'react'

import { acquiredClientsApi } from 'redux/services/acquired-clients'
import { GetAcquiredClientsParams } from 'redux/services/acquired-clients/types'

import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { formatDate } from 'shared/libs'

import { Filters, INITIAL_PARAMS } from './components/Filters'
import { ProductMetricsCell } from './components/ProductMetricsCell'

export const AcquiredClientsPage = () => {
  const [filters, setFilters] = React.useState<GetAcquiredClientsParams>({
    ...INITIAL_PARAMS,
    limit: 10,
    offset: 0,
  })
  const fetchState = acquiredClientsApi.useGetAcquiredClientsQuery(filters)

  const onChangeFilters = (newFilters: GetAcquiredClientsParams) => {
    newFilters.limit = filters.limit
    newFilters.offset = filters.offset
    setFilters(newFilters)
  }

  return (
    <AppLayoutTable
      title="Привлеченные"
      header={<Filters onSubmit={onChangeFilters} />}
    >
      {fetchState.isFetching && <AppLoader />}
      {fetchState.data && fetchState.isSuccess && (
        <>
          <AppTable
            dataSource={fetchState.data.results}
            headers={[
              {
                data: 'ИНН',
                key: 'inn',
              },
              {
                data: 'Наименование организации',
                key: 'organization_name',
              },
              {
                data: 'Адрес',
                key: 'address',
              },
              {
                data: 'Дата привлечения',
                key: 'acquisition_date',
                render: (_, item) => formatDate(item.acquisition_date),
              },
              {
                data: 'ФИО консультанта привлёкшего клиента',
                key: 'employee_name',
              },
              {
                data: 'ФИО супервайзера',
                key: 'supervisor_name',
              },
              {
                data: 'Продукт первого касания',
                key: 'first_touch_product_display',
              },
              {
                data: 'Обороты',
                key: 'product_metrics',
                render: (_, item) => (
                  <ProductMetricsCell
                    productMetrics={item.product_metrics}
                    valueKey="amount"
                  />
                ),
              },
              {
                data: 'Транзакции',
                key: 'product_metrics',
                render: (_, item) => (
                  <ProductMetricsCell
                    productMetrics={item.product_metrics}
                    valueKey="transaction_count"
                  />
                ),
              },
            ]}
          />

          <AppPagination
            forcePage={filters.offset! / filters.limit!}
            onPageChange={nextPage => {
              setFilters({
                ...filters,
                offset: (nextPage - 1) * filters.limit!,
              })
            }}
            count={fetchState.data.count / filters.limit!}
          />
        </>
      )}
    </AppLayoutTable>
  )
}
